// Filters for client-side noise that has no first-party fix. Kept in its own
// module (rather than inline in index.tsx) so the patterns can be unit tested.

export const ignoreErrors: RegExp[] = [
    // WebGL context creation failures from unsupported browsers/devices
    /Error creating WebGL context/,
    // Synthetic `unhandledrejection` events dispatched by third-party scripts.
    // A real browser rejection is a trusted PromiseRejectionEvent carrying a
    // `reason`; these are script-dispatched CustomEvents (isTrusted=false)
    // with no reason and no stacktrace, so there is nothing actionable.
    // https://thelab.sentry.io/issues/7692418549/
    /Event `(?:Custom)?Event` \(type=unhandledrejection\) captured as promise rejection$/,
    // Google Analytics beacons blocked by ad blockers, privacy extensions,
    // or flaky networks. The stacktrace is entirely gtag.js / extension
    // code; nothing first-party to fix. The SDK's fetch instrumentation
    // appends the request host to fetch TypeErrors (the
    // `enhanceFetchErrorMessages` option, enabled by default), so match
    // the browsers' three spellings of a failed fetch against Google
    // Analytics beacon hosts.
    // https://thelab.sentry.io/issues/7693100407/
    // https://thelab.sentry.io/issues/THELAB-CMS-6C/
    /(?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.) \((?:[a-z0-9-]+\.)*(?:google-analytics\.com|analytics\.google\.com)(?::\d+)?\)$/,
];

export const denyUrls: RegExp[] = [
    // Apollo.io website tracker — third-party sales intelligence script
    // https://thelab.sentry.io/issues/7382215442/
    // https://thelab.sentry.io/issues/7386155162/
    /assets\.apollo\.io/,
];
